// react components
import React, {
    useEffect,
    useState,
} from 'react'
import {
    IonSpinner,
} from '@ionic/react'

// props
type LoaderPageSiteProps = {
    color?: 'tertiary' | 'primary' | 'secondary'
    isOpen: boolean
}

// main
export const LoaderPageSite: React.FC<LoaderPageSiteProps> = React.memo(({
    color,
    isOpen,
}) => {

    if (!isOpen) return null

    return (
        <LoaderägeHelper
            color={color}
        />
    )
})

// props
type LoaderägeHelperProps = {
    color?: string
}

// main
const LoaderägeHelper: React.FC<LoaderägeHelperProps> = React.memo(({
    color,
}) => {

    const [showLoader, setShowLoader] = useState(false)

    let wto: any

    useEffect(() => {
        clearTimeout(wto)
        wto = setTimeout(() => {
            setShowLoader(true)
        }, 1000)
        return () => {
            clearTimeout(wto)
        }
    }, [])

    if (!showLoader) return null

    return (
        <div className='loader-page-site'>
            <IonSpinner
                color={color || 'primary'}
            />
        </div>
    )
})
